import { SegmentConditionType } from './segments.model';

export function segmentCondition() {
  return {
    restrict: 'E',
    template: require('./segment-condition.directive.html'),
    scope: {
      condition: '=',
      dropdownItems: '=',
      readonly: '<',
      segmentConditionOnCustomFieldChanged: '&',
    },
    controller: controller
  };
}

controller.$inject = ['$scope', 'AngularCustomFieldsService'];
function controller($scope, AngularCustomFieldsService) {
  $scope.formChanged = formChanged;

  $scope.typeCodes = SegmentConditionType.codes();
  $scope.conditionTypeCode = $scope.condition ? $scope.condition.typeCode : null;

  $scope.metrics = [{
    id: 1,
    label: 'weight'
  }, {
    id: 2,
    label: 'score'
  }];
  $scope.inequalityConditions = [{
    id: 1,
    name: 'greater_than',
    label: '>'
  }, {
    id: 2,
    name: 'equal',
    label: '='
  }, {
    id: 3,
    name: 'lower_than',
    label: '<'
  }];

  $scope.selectedSurveyScenario = $scope.condition.parameters && $scope.condition.parameters.surveyScenario
    ? $scope.dropdownItems.surveyScenarios.find(surveyScenario => surveyScenario.id === $scope.condition.parameters.surveyScenario.id)
    : null;
  $scope.selectedScenario = $scope.condition.parameters && $scope.condition.parameters.scenario
    ? $scope.dropdownItems.scenarios.find(scenario => scenario.id === $scope.condition.parameters.scenario.id)
    : null;
  $scope.selectedScenarioBox = $scope.selectedScenario
    ? $scope.selectedScenario.boxesWithBtns.find(box => box.id === $scope.condition.parameters.box)
    : null;

  _initConditionOnCustomFieldContext();

  $scope.onSurveyScenarioChange = () => {
    $scope.selectedSurveyScenario = $scope.dropdownItems.surveyScenarios.find(surveyScenario => surveyScenario.id === $scope.condition.parameters.surveyScenario.id);
    $scope.condition.parameters.box = null;
  };
  $scope.onScenarioChange = () => {
    $scope.selectedScenario = $scope.dropdownItems.scenarios.find(scenario => scenario.id === $scope.condition.parameters.scenario.id);
    $scope.condition.parameters.box = null;
  };
  $scope.onScenarioBoxChange = () => {
    $scope.selectedScenarioBox = $scope.selectedScenario.boxesWithBtns.find(box => box.id === $scope.condition.parameters.box);
    $scope.condition.parameters.button = null;
  };

  $scope.conditionTypeCodeChanged = (conditionTypeCode) => {
    $scope.condition.setTypeCode(conditionTypeCode);
    _initConditionOnCustomFieldContext();
  }

  function _initConditionOnCustomFieldContext() {
    if ($scope.condition.typeCode === 'custom-field') {
      $scope.context = {
        operatorsExcluded: [],
        customFields: $scope.dropdownItems.customFields,
        customFieldsMap: $scope.dropdownItems.customFieldsMap,
        description: AngularCustomFieldsService.updateDescription($scope.condition.parameters, $scope.dropdownItems.customFieldsMap)
      }
    }
  }

  function formChanged(value) {
    $scope.condition.parameters = value;
    $scope.segmentConditionOnCustomFieldChanged();
  }
}
